export const dayDeclension = (count: number, t: (key: string) => string): string => {
  if (!count || (count % 10 === 1 && count % 100 !== 11)) {
    return t('time.day');
  }

  if (count % 10 >= 2 && count % 10 <= 4 && !(count % 100 >= 12 && count % 100 <= 14)) {
    return t('time.dayAlt');
  }

  return t('time.days');
};
